import { ACTION } from './constants';
import request from '../../../../utils/request';
import {hideMainLoader, showMainLoader} from '../../../actions';
import {requestConfig} from "../../../../config/apiResource";

export const openPopup = (modalName, modalParameters) => {
        return { type:ACTION.OPEN_MODAL ,data: {modalName, modalParameters} }
};

export const closePopup = () => {
        return { type:ACTION.CLOSE_MODAL }
};


export const hideModalHeader = () => {
        return { type:ACTION.HIDE_MODAL_HEADER }
};
export function postInvestDataETF(data) {
    return dispatch => {
        return request(requestConfig.postInvestDataETF(data))
            .then((json) => {
                json && dispatch({ type: "POST_INVEST_ETF", data: json.data });
            }).catch((error) => {
                console.log("Got Error with subscribe POST_INVEST_ETF data: " + error)
            });
    }
}
export function sendOtp(formData) {
        return dispatch => {
                return request(requestConfig.sendOtp(formData))
                    .then((json) => {
                            json && dispatch({ type: ACTION.SEND_OTP , data: json.data });
                    }).catch((error) => {
                            console.log("Got Error with send otp: " + error)
                    });
        }
}
export function checkExistingUser(formData) {
        return dispatch => {
                return request(requestConfig.checkExistingUser(formData))
                    .then((json) => {
                            json && dispatch({ type: ACTION.SEND_OTP , data: json.data });
                    }).catch((error) => {
                            console.log("Got Error with send otp: " + error)
                    });
        }
}
export function verifyOTP(formData) {
    return dispatch => {
        return request(requestConfig.verifyOTP(formData))
            .then((json) => {
                json && dispatch({ type: ACTION.VERIFY_OTP , data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with verify otp: " + error)
            });
    }
}
export function clearVerifyResponse() {
    return {
        type: ACTION.CLEAR_VERIFY_OTP,
    }
}

export function clearSendOTP() {
    return {
        type: ACTION.CLEAR_SEND_OTP,
    }
}

export function getAccountStatement() {
    return dispatch => {
        return request(requestConfig.getAccountStatement())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_ACCOUNT_STATEMENT , data: json.data });
            }).catch((error) => {
                console.log("Got Error with  account statement api: " + error)
            });
    }
}


export function postRemuneration(formData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.postRemuneration(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.POST_REMUNERATION , data: json.data });
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with remuneration login: " + error)
            });
    }
}
export function getRemunerationYears(formData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getRemunerationYears(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_REMUNERATION_YEARS , data: json.data });
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with remuneration years data: " + error)
            });
    }
}
export function clearRemuneration() {
    return {
        type: ACTION.CLEAR_REMUNERATION
    }
};